/**
 * Enum for StackedSo event types.
 * @enum {string}
 */
export enum StackedSoEventType {
  /**
   * Event type for wearable scrap.
   */
  WEARABLE_SCRAP = 'wearable_scrap',
  // @TODO: Add more event types
}
